import axios from 'axios';

const getEntidade = () => axios.get('/entidades');
const getAllCompraConjunta = params => axios.get('/entidades/all/compra-conjunta', { params });

export default {
  getEntidade,
  getAllCompraConjunta,
};
